import { createComponent } from "react-fela";
import { stripSecurityAttributes } from "~/modules/video";

export default ({ content, extend }) => {
    if (!content) return null;

    return (
        <Video
            extend={extend}
            dangerouslySetInnerHTML={{
                __html: stripSecurityAttributes(content)
            }}
        />
    );
};

const videoStyles = {
    width: "100%",
    paddingTop: "56.25%",
    position: "relative",
    "> iframe": {
        width: "100%",
        height: "100%",
        top: "0px",
        position: "absolute"
    }
};

const Video = createComponent(videoStyles, "div", ["dangerouslySetInnerHTML"]);
